import { collection, addDoc, onSnapshot} from "firebase/firestore"; 
import { readable } from "svelte/store";
import {db} from '../firebase'

export class Notification {
    constructor(data) {
        Object.assign(this, data)
        return this
    }
    /*
    static create(shop, data = {details: ''}) {
        return addDoc(collection(db, "/stores/" + shop + "/notifications"), data)
    }
    */

    static realTime(shop) {
        return readable({}, (set) => {
            const ref = collection(db, "/stores/" + shop + "/notifications").withConverter(Notification.converters)
            const unsubscribeSnapshot = onSnapshot(ref, (querySnapShot) => {
                /* we got all the docs returned by the snapshot get their data (which is converted to class)
                    (using the .withConverter) and map the instances with their ID
                */
                const notifications = Object.fromEntries(querySnapShot.docs.map((item) => [item.id, item.data()]))
                set(notifications)
            })
            return () => unsubscribeSnapshot 
        })
        
    }
    static converters = {
        toFirestore: (notification) => {
            
        },
        fromFirestore: (snapshot, options = {}) => {
            const data = snapshot.data(options);
            return new Notification(data)
        }
    }
}